import {
  courierCashShipmentsEmployeeCollectionGuard,
  couriersCashShipmentCollectionGuard,
} from './_api/courierCash';

export const courierFilter = courierCashShipmentsEmployeeCollectionGuard;

export const routeGuard = couriersCashShipmentCollectionGuard;
